import {
    SimpleShowLayout,
    usePermissions,
    useRecordContext,
    useResourceContext,
} from "react-admin";
import { ContractDetails } from "../components/ContractDetails";
import { ToolbarWithHistory } from "shared/src/components/ToolbarWithHistory";
import { queryToAttribute } from "shared/src/utils/decodeQuery";
import { AccessRightsError } from "shared/src/components/AccessRightsError";
import { Spacer } from "shared/src/components/styles/Spacer";
import { EdispoDiffTable } from "./components/EdispoDiffTable";
import { RaShowView } from "shared/src/components/views/RaShowView";
import "./styles/rentalShow.css";
import { Box, CircularProgress, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { CarnetTable } from "./components/CarnetTable";
import { TabPanel } from "shared/src/components/tabs/TabPanel";
import { useInfiniteScroll } from "shared/src/hooks/useInfiniteScroll";

export const RentalShow = () => {
    const resource = useResourceContext();
    const attribute = queryToAttribute();
    const { isLoading, permissions } = usePermissions();

    if (isLoading) {
        return <></>;
    } else if (!permissions.vote({ resource, attribute })) {
        return <AccessRightsError />;
    }

    return (
        <RaShowView actions={<ToolbarWithHistory back={true} edit={true} delete={true} />}>
            <SimpleShowLayout>
                <ContentWrapper />
            </SimpleShowLayout>
        </RaShowView>
    );
};

const ContentWrapper = () => {
    const rental = useRecordContext();
    const [tabValue, setTabValue] = useState(0);

    const {
        data: rentalItems,
        isPending,
        isFetchingNextPage,
        observerRef,
    } = useInfiniteScroll(
        "rentalItems",
        {
            filter: { rental: rental?.id },
            pagination: { page: 1, perPage: 25 },
            sort: { field: "id", order: "ASC" },
        },
        { enabled: !!rental?.id }
    );

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    if (isPending) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <>
            <ContractDetails rentalItems={rentalItems} titleLabelKey={"equip.rentalDetails"} />
            <Spacer y={2} />
            <Box sx={{ width: "100%" }}>
                <Box sx={{ width: "100%" }}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        textColor="inherit"
                        variant="fullWidth"
                    >
                        <Tab label="Rental Items" />
                        <Tab label="Carnet" />
                    </Tabs>
                </Box>
                <TabPanel value={tabValue} index={0}>
                    <EdispoDiffTable equipData={rentalItems} />
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    <CarnetTable equipData={rentalItems} />
                </TabPanel>
            </Box>
            <Box ref={observerRef} sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                {isFetchingNextPage && <CircularProgress size={24} />}
            </Box>
        </>
    );
};
